.root {
  width: 100%;
  gap: 16px;
}

.formControl {
  min-width: 120px;
}
